import Hero from './Hero'
import SEO from './SEO'
import TechnologyStack from './TechnologyStack'

export default function Home() {
  return (
    <>
      <SEO
        title="We Build Digital Empires"
        description="Premium software startup building digital experiences. Custom websites, mobile apps, CRM systems, and business automation solutions."
        path="/"
      />
      <Hero />
      <TechnologyStack />
    </>
  )
}
